export enum GizmoModes {
  NONE = 'NONE',
  DEFAULT = 'DEFAULT',
  ARRANGEMENT = 'ARRANGEMENT',
}
